<template>
  <v-card>
    <v-card-title
      class="headline"
      primary-title>
      Edit Entity
    </v-card-title>
    <v-card-text v-if = "selectedItem && selectedItem.item">
      <v-form ref="entityExtForm">
        <label>Entity Name</label>
        <v-select
          v-model = "selectedItem.item.entityName"
          :items = "$store.state.nlp.entities.map(e => e.name)"
          placeholder = "Entity Name"
          :rules="[v => !!v || 'Entity Name is Required']"
          outline />
        <label>Attribute name</label>
        <v-text-field
          v-model = "selectedItem.item.saveTo"
          placeholder = "Attribute name"
          :rules="[v => !!v || 'Attribute name is Required']"
          outline />
        <label>Default value</label>
        <v-text-field
          v-model = "selectedItem.item.defaultValue"
          placeholder = "Default value"
          :rules="[v => !!v || 'Default value is Required']"
          outline />
        <label>Required </label>
        <v-checkbox
          v-model = "selectedItem.item.required"
          placeholder = "Required"
          color="primary" />
        <label>Question</label>
        <v-text-field
          v-model = "selectedItem.item.question"
          placeholder = "Question"

          outline />
        <label>Regex</label>
        <v-text-field
          v-model = "selectedItem.item.regex"
          placeholder = "Regex"

          outline />
        <label>Error message</label>
        <v-text-field
          v-model = "selectedItem.item.errorMessage"
          placeholder = "Error message"

          outline />
      </v-form>
    </v-card-text>

    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        outline
        @click="$emit('closeDialog')">
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="submit">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "entityExtractionForm",
    props: {
      selectedItem: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      openMode: {
        type: String,
        default: 'add'
      }
    },
    methods: {
      submit() {
        if (this.$refs.entityExtForm.validate()){
          if (this.openMode === 'edit') {
            this.$emit('saveItem', this.selectedItem)
          } else {
            this.$emit('addItem', this.selectedItem)
          }

        }
      }
    }
  }
</script>

<style scoped>

</style>
